import { ModuleNames } from '../../src/constants/componentNames.constants'
import MODULE_MAPPING from '../constants/contentIDs'
import ModuleMapping from '../constants/modulesMapping'

//* component formatter
import { EntryLocaleMatch } from '../../src/constants/localization.constants'
import RandomizerUtil from '../../src/utils/randomizer.utils'

//* It recursively extracts the UI fields from the Contentful Delivery API
export const dataFormatterRecursive = (item: any, __typename = '', id: string, locale: string) => {
  try {
    const typename = ModuleMapping[__typename] || __typename
    const res: any = { ...item, __typename: typename, id: id || '' }

    if (typename === ModuleNames.RESOURCE_ROW) {
      if (res.randomize) {
        res.featuredPages = RandomizerUtil.getRandomItemsFromArray(item.featuredPages, 5)
      }

      res.featuredPages = res.featuredPages.slice(0, 5)
    }

    if (typename === ModuleNames.MENU_NAV) {
      res.node_locale = EntryLocaleMatch[res.entryLocale]
    }

    if (!res.node_locale) res.node_locale = locale

    for (const key in res) {
      const currId = res[key]?.sys?.id
      const currLocale = res[key]?.sys?.locale

      if (key === 'referrer' && typename === ModuleNames.PAGE_WEBINAR_RECORDING) {
        addBioReferences(res[key]?.fields)
      }

      if (res[key]?.fields && res[key]?.sys?.contentType) {
        res[key] = dataFormatterRecursive(
          res[key].fields,
          res[key].sys.contentType.sys.id,
          currId,
          currLocale
        )
      } else if (res[key]?.fields && res[key]?.sys?.type === 'Asset') {
        res[key] = dataFormatterRecursive(res[key].fields, res[key].sys.type, currId, currLocale)
      } else if (Array.isArray(res[key])) {
        res[key] = res[key].map((item: any) => {
          const itemId = item.sys?.id
          return item.fields && item.sys?.contentType
            ? dataFormatterRecursive(item.fields, item.sys.contentType.sys.id, itemId, currLocale)
            : item
        })
      } else {
        res[key] = typeof res[key] === 'object' ? { ...res[key] } : res[key]
      }
    }

    return res
  } catch (err) {
    console.log(`Error in formatting data: ${err}`)
  }
}

const addBioReferences = (res: any) => {
  if (res?.body?.content?.length) {
    const rtfWithSpeakers = res.body.content.filter(
      (item: any) =>
        item?.nodeType === 'embedded-entry-block' &&
        item?.data?.target?.sys?.contentType?.sys?.id === MODULE_MAPPING.COMPONENT_BIO
    )

    const bioReferences: any = []
    rtfWithSpeakers.forEach((item: any) => {
      if (item?.data?.target?.fields) bioReferences.push(item.data.target)
    })

    const rtfWithoutSpeakers = res.body.content.filter(
      (item: any) =>
        item?.nodeType !== 'embedded-entry-block' &&
        item?.data?.target?.sys?.contentType?.sys?.id !== MODULE_MAPPING.COMPONENT_BIO
    )

    res.body.content = rtfWithoutSpeakers
    res['bioRTF'] = bioReferences
  }
}
